<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :pagination="false" :loading="tloading" rowKey="id" @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <a class="tableLink" href="javascript:;" @click="handleRelatedPassways(record)">关联通道</a>
                <a-button type="link" @click="handleMessagePush(record)">推送</a-button>
                <a-button type="link" @click="handleTempletePush(record)">模板</a-button>

                <router-link class="tableLink" :to="{path:'detail_channel',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink" :to="{path:'edit_channel',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

            <template slot="status" slot-scope="text">
                <span v-if="text == '02'">
                    开启
                </span>
                <span v-else-if="text == '01'">
                    未开启
                </span>
                <span v-else>
                    --
                </span>
            </template>

            <template slot="platforms" slot-scope="text">
                <span v-if="platforms.filter((n) => {return n.platformtype == text} ).length > 0">
                    {{ platforms.filter((n) => {return n.platformtype == text} )[0].platformtypename }}
                </span>
                <span v-else>--</span>
            </template>

        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        <authE ref="autheEID" @onRefresh="onRefresh"></authE>
    </div>
</template>
<script>
import authE from './auth'
let mcmsmanagerstoreKey = 'commonChannelCode'
let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    // {
    //     title: "序号",
    //     width: 50,
    //     align: "center",
    //     customRender: (text, record, index) => {
    //         let { page, pageSize } = pagination;
    //         return (Number(page) - 1) * Number(pageSize) + index + 1;
    //     }
    // },

    {
        title: '渠道编码',
        dataIndex: 'channelcode',
        align: 'center',
        width: 120,
    },
    {
        title: '渠道名称',
        dataIndex: 'channelname',
        align: 'center',
        width: 120,
    },
    {
        title: '平台编码',
        dataIndex: 'platformtype',
        scopedSlots: { customRender: 'platforms' },
        align: 'center',
        width: 120,
    },
    {
        title: '渠道状态',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' },
        align: 'center',
        width: 100,
    },
    {
        title: '通道',
        dataIndex: 'passwaynames',
        align: 'center',
        width: 120,
    },

    // {
    //     title: "创建时间",
    //     dataIndex: "createtime",
    //     width:200
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatetime",
    //     width:150
    // },
    // {
    //     title: "更新人",
    //     dataIndex: "updatetuser",
    //     width:150
    // },
    // {
    //     title: "创建人",
    //     dataIndex: "createuser",
    //     width:150
    // },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            ordercoloum: 'total',
            orderstr: 'desc',
            searchP: {},
            platforms: [],
        }
    },
    methods: {
        handleRelatedPassways(record) {
            // 关联通道
            this.$refs.autheEID.showModal({
                channelcode: record.channelcode,
                channelname: record.channelname,
            })
        },
        handleMessagePush(record) {
            localStorage.setItem(mcmsmanagerstoreKey, record.channelcode)
            this.$router.push({
                path: '/mcmsmanager/message/messagepush',
            })
        },

        handleTempletePush(record) {
            localStorage.setItem(mcmsmanagerstoreKey, record.channelcode)
            this.$router.push({
                path: '/mcmsmanager/templete/app',
            })
        },

        handleTableChange(d, v, sorter) {
            if (sorter.order) {
                this.ordercoloum = sorter.field
                this.orderstr = sorter.order.replace('end', '')
            } else {
                this.ordercoloum = ''
                this.orderstr = ''
            }

            this.getAppSumData()
        },
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        handleDelete(item) {
            let that = this
            that.$store
                .dispatch({
                    type: 'mcmsmanager/deletechannel',
                    params: { id: item.id },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        onRefresh() {
            this.getAppSumData()
        },
        getAppSumData() {
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'mcmsmanager/querychannelpage',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSearch(searchP) {
            this.searchP = searchP
            this.pagination.page = 1
            this.getAppSumData()
        },
        getPlatforms() {
            let that = this
            let c_params = {
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'mcmsmanager/platforms',
                    params: c_params,
                    showMsg: false,
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        that.platforms = []
                        let result = res.data.data
                        if (!result) {
                            that.message.error('未查询到平台')
                            return
                        }
                        that.platforms = result
                    }
                })
                .catch(() => {})
        },
    },

    components: {
        authE,
    },
    mounted() {
        this.getPlatforms()
    },
}
</script>
<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}
</style>

